import React, { useState, useContext, useEffect } from 'react';
import { Link } from 'react-router-dom';

import AlertaContext from '../../context/alertas/alertaContext';
import AuthContext from '../../context/autenticacion/authContext';

const Login = (props) => {

    // extraer los valores del context
    const alertaContext = useContext(AlertaContext);
    const { alerta, mostrarAlerta } = alertaContext;

    const authContext = useContext(AuthContext);
    const { mensaje, autenticado, iniciarSesion } = authContext; 

    // en caso de que el ususario o psw no existan
    useEffect(() => {
        if (autenticado) { 
            props.history.push('/proyectos');
        }
        if (mensaje) {
            mostrarAlerta(mensaje.msg, mensaje.categoria);
        }
        // eslint-disable-next-line
    }, [mensaje, autenticado, props.history])

    // state par iniciar sesion
    const [usuario, setUsuario] = useState({
        email: '',
        password: ''
    })

    const { email, password } = usuario;

    const onChange = e =>{
        setUsuario({
            ...usuario,
            [e.target.name] : e.target.value
        })
    }

    // cuando el usario quiere iniciar sesion

    const onSubmit = e => {
        e.preventDefault();

        // Validar que no haya campos vacios
        if (email.trim() === '' || password.trim() === '') {
            mostrarAlerta('Todos los campos son obligatorios', 'alerta-error');
        }

        // Pasarlo al action
        iniciarSesion({email, password});
    }

    return ( 
        <> 
        <h1>ELECTRO<span>NATURAL</span></h1>
        <div className="form-usuario">
        
            {alerta ? (<div className={`alerta ${alerta.categoria}`}>{alerta.msg}</div>) : null}
            <div className="contenedor-form">
                <h1 className="form-label">Iniciar Sesión</h1>
                <form
                    onSubmit={onSubmit}
                >
                    <div className="mb-3">
                        <label htmlFor="email" className=" form-label">Email</label>
                        <input 
                            type="email"
                            className="form-control input-text"
                            name="email"
                            value={email}
                            placeholder="Tu Email"
                            onChange={onChange}
                            aria-describedby="email"/>
                    </div>
                    <div className="mb-3">
                        <label htmlFor="password" className="form-label">Password</label>
                        <input 
                            type="password"
                            className="form-control input-text" 
                            name="password"
                            value={password}
                            placeholder="Tu password"
                            onChange={onChange}
                        />
                    </div>
                    <button 
                        type="submit" 
                        className="btn btn-primary text-uppercase d-block w-100"
                        value="Iniciar Sesión"
                    >Iniciar Sesión</button>
                </form>
                <Link 
                    to={'/nueva-cuenta'} 
                    className="enlace-cuenta">
                Obtener Cuenta</Link>
            </div>
        </div>
        </>
    );
}
 
export default Login;